<template>
  <div class="content-page" style="min-height:800px;">
    <loading :show="show"></loading>
    <div class="Breadcrumb" style="z-index: 0;">
      <!--面包屑导航-->
      <Breadcrumb separator=">">
        <Breadcrumb-item href="/">
          <router-link to="/index">
            <i class="iconfont icon-home"></i>
            <span>首页</span>
          </router-link>
        </Breadcrumb-item>
        <Breadcrumb-item href="/">
          <router-link
              :to="'/'+$route.params.type"
          >{{this.typeDict[this.$route.params.type]}}</router-link>
        </Breadcrumb-item>
        <Breadcrumb-item href="/">
          <!-- <router-link style="vertical-align:middle;" :to="'/'+$route.params.type+'/'+currentSystem.System"></router-link> -->
          {{this.currentSystem.name}}
        </Breadcrumb-item>
        <Breadcrumb-item href="/">{{this.tabName}}</Breadcrumb-item>
      </Breadcrumb>
      <!--面包屑导航结束-->
    </div>
    <div>
      <div class="type_div clearfix">
        <!--左侧导航栏-->
        <div class="type_menu_div animate">
          <div class="type_menu_body_div">
            <div class="type_navigation_div" v-for="(items,key) in isShow" v-if="items" >
              <div @click="goKey(key)"
                   class="type_navigation_blueModel_div"
                   :class="{type_navigation_blueModel_div_selected:$route.params.name===key}">
                <span>{{getKeyName(key)}}</span><span class="dot"></span>
              </div>
            </div>
          </div>

        </div>
        <!--左侧导航栏结束-->
        <!--右侧内容-->
        <div class="type_title">
          <div id="left1">
            <div class="database_function_div">
              <!--选项卡-->
              <div class="function_top_model_div">
                <div style="width:750px;margin:0 auto;">
                  <!--查询-->
                  <div class="three_div">
                    <div
                        class="tableview_div"
                        :class="{data_select_div:this.currentTab==='TableView'}"
                        @click="toggleTab('TableView')">
                      <i class="iconfont icon-sousuo"></i>
                      <span>查询</span>
                    </div>
                  </div>
                  <!--样本与字段说明-->
                  <div class="three_div">
                    <div
                        class="explain_div"
                        :class="{data_select_div:this.currentTab==='FieldInfoAndSimpleData'}"
                        @click="toggleTab('FieldInfoAndSimpleData')"
                    >
                      <i class="iconfont icon-ziduan"></i>
                      <span>样本与字段说明</span>
                    </div>
                  </div>
                  <!--数据库说明-->
                  <div class="three_div">
                    <div
                        class="dataInstructions_div"
                        :class="{data_select_div:this.currentTab=='DBIntro'}"
                        @click="toggleTab('DBIntro')"
                    >
                      <i class="iconfont icon-shujuku"></i>
                      <span>数据库说明</span>
                    </div>
                  </div>
                </div>
              </div>
              <!--选项卡结束-->

              <div class="loading_div">
                <i class="icon icon-spin icon-spinner-snake icon-3x"></i>
              </div>
              <div class="tabs">
                <component @changeModelCard="changeCurrentTabByEmit" @showHistory='showHistoryModel' v-bind:is="currentTab" @ChangeCurrentTab="ChangeCurrentTab"></component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableView from "../../../../components/TableView.vue";
import DBIntro from "../../../../components/DBIntro.vue";
import FieldInfoAndSimpleData from "../../../../components/FieldInfoAndSimpleData.vue";
import loading from "@/components/loading/loading";
import {mapState} from "vuex";
import axios from "@/api/axios";
import {login} from "../../../../store/actions";

export default {
  name: 'name',

  data() {
    return {
      currentTab: "TableView",
      currentViewName: null,
      show: false,
      typeDict: {
        gsgg: "公司公告",
        xwbd: "新闻报道",
        yjbg: "研究报告",
        gsjg: "公司研究",
        qtwb: "综合文本"
      },
      systemConfig: [],
      isShow: {
        analysis: false,
        cipin: false,
        qinggan: false,
        readable: false,
        simtable: false,
        newSimtable:false,
        报刊财经新闻基本信息: false,
        报刊财经新闻相似度: false,
        报刊财经新闻量化统计: false,
        网络新闻量化统计_按交易时间: false,
        网络新闻量化统计_按自然日: false,
        网络财经新闻基本信息: false,
        网络财经新闻相似度: false,
        股吧文章统计_按交易时间: false,
        股吧文章统计_按自然日: false
      },
      routerLinkUrl: '',
      tabName:''
    };
  },
  watch: {
    $route(to, from) {
      this.init();
      this.getSystemConfig()
    },
    "$route.path": function (newVal, oldVal) {
      this.show= true
      this.getSystemConfig()
      setTimeout(()=>{
        this.show = false
      },400)

    }
  },
  created() {
    this.getSystemConfig()

  },
  mounted() {
    this.init();
    $('[data-toggle="tooltip"]').tooltip();
    this.tabName = this.currentTableInfo.name
  },
  updated() {
    // this.editLocaltionText_select();
  },
  methods: {
    getKeyName(key) {
      if (key === 'analysis') return '基本信息'
      if (key === 'cipin') return '词频统计'
      if (key === 'qinggan') return '语调分析'
      if (key === 'readable') return '可读性'
      if (key === 'simtable') return '同行业相似度'
      if (key === 'newSimtable') return '同公司相似度'
      else return key;
    },
    goKey(key) {
      this.tabName = this.getKeyName(key);
      this.$router.replace(this.routerLinkUrl + key);
    },
    changeCurrentTabByEmit(value) {
      this.currentTab = value
    },
    showHistoryModel() {
      this.$emit("showHistoryModel")
    },
    ChangeCurrentTab() {
      this.currentTab = "TableView";
    },
    toggleTab(currentTab) {
      this.currentTab = currentTab;
    },
    init() {
      $('[data-toggle="tooltip"]').tooltip();
      // this.currentDB = this.$route.params.db;
      // this.currentViewName = this.$route.params.ViewNam+e;
      this.currentTab = "TableView";
    },
    //获取当前数据库配置信息，只有数据库有的模块才显示
    getSystemConfig(){
      axios.get("/api/getSystemList").then(res => {
        this.systemConfig = []
        const list = res.data.SystemList
        const viewname = this.$route.params.viewname
        for(let key in list[viewname]["tableInfo"]){
          if (viewname === "CFND_HighTrail") {
            this.systemConfig.push(key);
          } else {
            let arr = key.split("-");
            this.systemConfig.push(arr[1])
          }
        }
        for(let show in this.isShow){
          this.isShow[show] = this.systemConfig.includes(show);
          if (this.$route.params.viewname === "GUBA") {
            this.isShow["cipin"] = false
          }
          //  || show=="simtable" || show=="newSimtable"
          if(show=="cipin"){
            this.isShow[show] = false;
          }
          // if(show=="cipin" && viewname=="AnalystReport"){
          //   this.isShow[show] = true;
          // }
        }
      }).catch(err=> {
        console.log(err);
      })

    }
  },
  components: {
    TableView: TableView,
    DBIntro: DBIntro,
    loading: loading,
    FieldInfoAndSimpleData: FieldInfoAndSimpleData
  },
  computed: {
    ...mapState(["SystemList"]),
    currentSystem() {
      if (this.SystemList[this.$route.params.viewname]) {
        return this.SystemList[this.$route.params.viewname];
      } else {
        return {};
      }
    },
    currentTableInfo() {
      if (this.currentSystem && this.currentSystem["tableInfo"]) {
        this.routerLinkUrl = '/views/' + this.$route.params.type + '/' + this.currentSystem.system + '/'
        if (this.$route.params.viewname === 'CFND_HighTrail') {
          return this.currentSystem["tableInfo"][this.$route.params.name];
        } else {
          return this.currentSystem["tableInfo"][this.currentSystem.prefixName + "-" + this.$route.params.name];
        }
      } else {
        return {};
      }
    }
    // ...mapState(['SystemDBDic', 'CurrentPaths', 'TableInfoDic','allSystemList']),
    // ...mapGetters(['getCurrentPathStr']),
    // CurrentPath() {
    // },
    // CurrentViewDBToDB() {
    //     return this.systemList.filter(s => s.DB == this.currentDB)[0];
    // },
    // systemList() {
    //     return this.allSystemList;
    // }
  },
};
</script>


<style lang="scss">
/* 媒体查询 */
@media (min-width: 1560px){
  .Breadcrumb,.type_div{
    width: 1413px;
  }
  .type_menu_body_div {
    width: 200px;
  }
  .type_title {
    width: 1100px;
  }
}
@media (min-width: 1420px){
  @media (max-width: 1560px){
    .Breadcrumb,.type_div{
      width: 1176px;
    }
    .type_menu_body_div {
      width: 180px;
    }
    .type_title {
      width: 900px;
    }
  }
}
@media (min-width: 1200px){
  @media (max-width: 1420px){
    .Breadcrumb,.type_div{
      width: 1075px;
    }
    .type_menu_body_div {
      width: 160px;
    }
    .type_title {
      width: 830px;
    }
  }
}
@media (min-width: 1000px){
  @media (max-width: 1200px){
    .Breadcrumb,.type_div{
      width: 956px;
    }
    .type_menu_body_div {
      width: 140px;
    }
    .type_title {
      width: 730px;
    }
  }
}
@media (max-width: 1000px){
  .Breadcrumb,.type_div{
    width: 837px;
  }
  .type_menu_body_div {
    width: 120px;
  }
  .type_title {
    width: 650px;
  }
}

/* content-page */
.content-page {
  margin: auto;
  background:white;
}

/* 面包屑导航 */
.icon-home{
  margin-right: 4px;
  font-size: 16px;
}
.Breadcrumb{
  margin: 0 auto;
  padding-left: 16px;
  position: relative;
  z-index:999;
  margin: 15px auto;
  vertical-align:middle;
}
.ivu-breadcrumb a{
  color: rgba(0,0,0,.45);
}
.ivu-breadcrumb-item-separator {
  margin: 0 8px 0 5px;
}
.ivu-breadcrumb a:hover {
  color: #4184f3;
}
.ivu-breadcrumb>span:last-child {
  font-weight: 500;
  color: #4184f3;
}

/* type */
.type_div {
  margin: 0px auto;
  position: relative;
  padding-left: 15px;
}

/* 左侧导航 */
.type_menu_div {
  float: left;
  position: relative;
  border-right:1px solid #dae0eb;
  margin-top: 15px;
}

.type_menu_body_div {
  height: 100%;
  margin: 0 auto;
}

.type_menu_body_div a:focus{
  outline: none;
  text-decoration: none;
}
.type_navigation_blueModel_div_selected{
  background: rgba(65,132,243,.1) !important;
  color: #4184f3!important;
  border-right: 2px solid #4184f3 !important;
  cursor: auto;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.type_navigation_div {
  height: 45px;
  width: 100%;
  position: relative;
}

.type_navigation_blueModel_div {
  width: 100%;
  height: 45px;
  line-height: 45px;
  top: 45px;
  text-align: left;
  padding-left: 21px;
  color: #515a6e;
  background-color: white;
  cursor: pointer;
  transition: ease all 0.2s;
  -webkit-transition: ease all 0.2s; /* Safari and Chrome */
  -moz-transition: ease all 0.2s; /* Firefox */
  -ms-transition: ease all 0.2s; /* Opera */
}

.type_navigation_blueModel_div span {
  position: relative;
}

.dot {
  position: relative;
  border-radius: 50%;
  background-color: #5e97f5;
  width: 11px;
  height: 11px;
  animation: ani-spin-bounce .8s ease 1;
  -webkit-animation: ani-spin-bounce .8s ease 1;
  animation-fill-mode:forwards;
  -webkit-animation-fill-mode:forwards; /* Safari 和 Chrome */
  margin: 0px auto;
  float: right;
  top: 18px;
  right: 15px;
  display: none;
}

.type_navigation_blueModel_div_selected .dot{
  display: inline-block;
}
/* 右侧内容 */
.type_title {
  float: right;
  margin-top: 15px;
}

.database_function_div {
  float: left;
  position: relative;
  font-family: "Microsoft YaHei", Arial;
  width: 100%;
  .tabs {
    overflow: hidden;
    margin: 0px 0 30px;
    width: 100%;
    float: left;
    padding-top: 5px;
  }
}

.function_top_model_div {
  float: left;
  overflow: hidden;
  width: 100%;
  border-bottom: 1px solid #dae0eb;
  & > div > div {
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    height: 45px;
    font-weight: 700;
    float: left;
  }
  & > div > div:hover{
    color: #4184f3;
    transition: ease all 0.4s;
    -webkit-transition: ease all 0.4s;
    -moz-transition: ease all 0.4s;
    -ms-transition: ease all 0.4s;

  }
  span {
    line-height: 45px;
  }
}
/* 选项卡 */
.three_div{
  width: 200px;
  margin: 0px 15px;
}
.three_div .iconfont {
  font-size: 26px;
  font-weight: 500;
  vertical-align: middle;
  margin-right: 5px;
}
.icon-sousuo{
  font-size: 30px!important;
}
.icon-shujuku{
  font-size: 25px!important;
  margin-right: 9px!important;
}
//选中
.data_select_div {
  color: #4184f3;
  background-color: white;
  border: 1px solid #dae0eb!important;
  border-bottom: 2px solid #4184f3 !important;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}
//查询
.tableview_div {
  width: 150px;
  margin: 0px auto;
}
//样本与字段说明
.explain_div {
  width: 200px;
  margin: 0px auto;
}
//数据库说明
.dataInstructions_div {
  width: 175px;
  margin: 0px auto;
}
.tableview_div,.explain_div,.dataInstructions_div{
  border-radius: 4px 4px 0 0;
  border: 2px solid white;
  height: 45px;
}

/* loading */

//.loading_div {
//  text-align: center;
//  height: 600px;
//  position: relative;
//  i {
//    position: absolute;
//    top: 50%;
//    left: 50%;
//    margin-top: -25px;
//    margin-left: -25px;
//  }
//}


/* 没看懂 */
.database_function_div {
  .slider {
    position: absolute;
    height: 1px;
    overflow-x: hidden;
    right: 0;
    left: 0;
  }

  .line {
    position: absolute;
    opacity: 0.4;
    background: #4a8df8;
    width: 150%;
    height: 5px;
  }

  .subline {
    position: absolute;
    background: #4a8df8;
    height: 5px;
  }
  .inc {
    animation: increase 1s infinite;
  }
  .dec {
    animation: decrease 1s 0.5s infinite;
  }

  @keyframes increase {
    from {
      left: -5%;
      width: 5%;
    }
    to {
      left: 130%;
      width: 100%;
    }
  }
  @keyframes decrease {
    from {
      left: -80%;
      width: 80%;
    }
    to {
      left: 110%;
      width: 10%;
    }
  }
}

$btncolor: #0b5594;
$border-liner: 1px solid $btncolor;



.tooltip {
  font-size: 12px !important;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.databaseIndex {
  height: 40px;
  width: 100%;
  overflow: hidden; // border-bottom: 1px solid #ccc;
  font-size: 16px;
  span {
    position: relative;
    top: 15px;
  }
}
//
//.animate{
//  position:relative;
//  animation:Graduallyinto 0.4s;
//  -webkit-animation:Graduallyinto 0.4s; /* Safari and Chrome */
//  -moz-animation:Graduallyinto 0.4s; /* Firefox */
//  -o-animation:Graduallyinto 0.4s; /* Opera */
//}
//@keyframes Graduallyinto
//{
//  0%   {opacity:0;}
//  100% {opacity:1;}
//}
//@-moz-keyframes Graduallyinto /* Firefox */
//{
//  0%   {opacity:0;}
//  100% {opacity:1;}
//}
//@-webkit-keyframes Graduallyinto /* Safari and Chrome */
//{
//  0%   {opacity:0;}
//  100% {opacity:1;}
//}
//@-o-keyframes Graduallyinto /* Opera */
//{
//  0%   {opacity:0;}
//  100% {opacity:1;}
//}
</style>







